import * as React from 'react';

import classNames from 'classnames';

import * as s from './ErrorScreen.scss';

export interface IErrorScreenProps {
	className?: string;
	children: React.ReactNode;
}

export const ErrorScreen = (props: IErrorScreenProps) => {
	const {
		className,
		children,
	} = props;

	return <div className={classNames(s.block, className)}>
		{children}
	</div>;
};
